/* eslint-disable no-unused-vars */
import { Module, VuexModule, Mutation } from "vuex-module-decorators";

@Module({ namespaced: true, preserveState: true })
class GlobalModule extends VuexModule {
  wsReady = false;

  @Mutation
  setWsReady(ready: boolean) {
    this.wsReady = ready;
  }
}

export default GlobalModule;
